<template>
  <el-form>
    <el-form-item label="选择平台">
      <el-select v-model="key">
        <el-option value="0" label="同舟"> </el-option>
        <el-option value="1" label="代理通"> </el-option>
        <el-option value="2" label="同程"> </el-option>
        <el-option value="3" label="飞猪"> </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="cookie值">
      <el-input
        v-model="cookie"
        type="textarea"
        placeholder="请输入cookie值"
      ></el-input>
    </el-form-item>

    <el-button type="primary" @click="submit">提交</el-button>
  </el-form>
</template>

<script>
  import { orderApi } from '../api/api';
  export default {
    data() {
      return {
        key: '0',
        cookie: '',
      };
    },
    methods: {
      submit() {
        if (this.cookie) {
          orderApi.cookie(this).then(r => {
            if (r.code == 0) {
              this.$message.success('更新成功');
            } else {
              this.$message.error('更新失败');
            }
          });
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// cookie.vue?c6e52334